const componentsProps = {
  textField: {
    outlined: true,
    dense: true,
  },
  get validatedField() {
    return {
      ...this.textField,
      height: '40px',
    };
  },
  get shortTextField() {
    return {
      ...this.textField,
      height: '32px',
    };
  },
  get disabledInput() {
    return {
      ...this.textField,
      readonly: true,
      hideDetails: true,
      height: '40px',
    };
  },
  get select() {
    return {
      ...this.shortTextField,
      hideDetails: true,
      menuProps: { offsetY: true },
    };
  },
  get multiselect() {
    return {
      ...this.select,
      clearable: true,
      multiple: true,
    };
  },
  chipsMultiselect: {
    outlined: true,
    multiple: true,
    smallChips: true,
    deletableChips: true,
  },
  datePicker: {
    headerTitle: 'Wybierz datę',
    firstDayOfWeek: '1',
    disableLookup: true,
    locale: 'pl',
    color: 'primary',
  },
  datePickerMenu: {
    transition: 'scale-transition',
    contentClass: 'moved',
    offsetY: true,
    closeOnContentClick: false,
  },
  get dateTextField() {
    return {
      ...this.validatedField,
      persistentHint: true,
      readonly: true,
      placeholder: 'Wybierz datę',
      class: 'input-calendar',
      appendIcon: 'mdi-calendar-month-outline',
    };
  },
};

export default componentsProps;
